import React from "react";

import "./WhyUseApkModal.scss";
import FilledButton, {
  ButtonSizes,
} from "../../../../components/dashboard-page/FilledButton/FilledButton";
import BottomDrawer from "../../../../components/BottomDrawer/BottomDrawer";

function WhyUseApkModal({
  show,
  onHide,
}: {
  show: boolean;
  onHide: VoidFunction;
}) {
  return (
    <BottomDrawer isOpen={show} onClose={onHide}>
      <div className="why-use-apk-modal">
        <h2 className="pt-2">Here's why we use an APK</h2>
        <div className="explanation mb-4">
          <span className="mb-1 d-block">
            APKs are apps that are not on the Google Play Store.
          </span>
          <br />
          <span>
            Apps that allow gamers win rewards from games of skill are still
            under review by Google. Only gambling apps (games of chance) are
            allowed by Google. Apple App Store allows our app.
          </span>
        </div>
        <p className="px-3">
          <FilledButton size={ButtonSizes.MD} fullwidth onClick={onHide}>
            Okay
          </FilledButton>
        </p>
      </div>
    </BottomDrawer>
  );
}

export default WhyUseApkModal;
